var map = {
	"./blaueskreuz-musub-logo": 7,
	"./blaueskreuz-musub-logo.jpg": 7,
	"./donate/twint-qr-code": 8,
	"./donate/twint-qr-code.jpg": 8,
	"./icons/logo": 9,
	"./icons/logo-short": 10,
	"./icons/logo-short.svg": 10,
	"./icons/logo-sqs": 11,
	"./icons/logo-sqs.png": 11,
	"./icons/logo.svg": 9,
	"./icons/mail-circle": 12,
	"./icons/mail-circle.svg": 12,
	"./icons/online-circle": 13,
	"./icons/online-circle.svg": 13,
	"./icons/phone-circle": 14,
	"./icons/phone-circle.svg": 14,
	"./locations/basel": 15,
	"./locations/basel-map": 16,
	"./locations/basel-map.jpg": 16,
	"./locations/basel.jpg": 15,
	"./locations/liestal": 17,
	"./locations/liestal-map": 18,
	"./locations/liestal-map.jpg": 18,
	"./locations/liestal.jpg": 17,
	"./locations/muenchenstein": 19,
	"./locations/muenchenstein-map": 20,
	"./locations/muenchenstein-map.jpg": 20,
	"./locations/muenchenstein.jpg": 19,
	"./og-bkbb-musub-logo": 21,
	"./og-bkbb-musub-logo.jpg": 21,
	"./partner/baselland-amt-fuer-gesundheit": 22,
	"./partner/baselland-amt-fuer-gesundheit.png": 22,
	"./partner/baselstadt-medizinische-dienste": 23,
	"./partner/baselstadt-medizinische-dienste.png": 23,
	"./partner/gesundheitsdepartement_bs": 24,
	"./partner/gesundheitsdepartement_bs.png": 24,
	"./partner/prevent-bs": 25,
	"./partner/prevent-bs.jpg": 25,
	"./partner/psychiatrie-baselland": 26,
	"./partner/psychiatrie-baselland.png": 26,
	"./partner/safezone": 27,
	"./partner/safezone.png": 27,
	"./partner/upk-basel": 28,
	"./partner/upk-basel.png": 28,
	"./placeholders/angebot": 29,
	"./placeholders/angebot.jpg": 29,
	"./placeholders/angehoerige": 30,
	"./placeholders/angehoerige.jpg": 30,
	"./placeholders/arbeitgeber": 31,
	"./placeholders/arbeitgeber.jpg": 31,
	"./placeholders/article-placeholder": 32,
	"./placeholders/article-placeholder.jpg": 32,
	"./placeholders/beistandschaften": 33,
	"./placeholders/beistandschaften.jpg": 33,
	"./placeholders/betroffene": 34,
	"./placeholders/betroffene.jpg": 34,
	"./placeholders/covid": 35,
	"./placeholders/covid.jpg": 35,
	"./placeholders/empfang": 36,
	"./placeholders/empfang.jpg": 36,
	"./placeholders/entzug": 37,
	"./placeholders/entzug.jpg": 37,
	"./placeholders/gruppenprogramm": 38,
	"./placeholders/gruppenprogramm.jpg": 38,
	"./placeholders/jugendliche": 39,
	"./placeholders/jugendliche.jpg": 39,
	"./placeholders/kaufsucht": 40,
	"./placeholders/kaufsucht.jpg": 40,
	"./placeholders/praevention": 41,
	"./placeholders/praevention.jpg": 41,
	"./placeholders/psychiatrische-sprechstunde": 42,
	"./placeholders/psychiatrische-sprechstunde.jpg": 42,
	"./placeholders/schulsozialdienst": 43,
	"./placeholders/schulsozialdienst.jpg": 43,
	"./placeholders/spenden": 44,
	"./placeholders/spenden-box": 45,
	"./placeholders/spenden-box.jpg": 45,
	"./placeholders/spenden.jpg": 44,
	"./placeholders/substances": 46,
	"./placeholders/substances.jpg": 46,
	"./placeholders/team": 47,
	"./placeholders/team.jpg": 47,
	"./placeholders/villa": 48,
	"./placeholders/villa.jpg": 48,
	"./placeholders/worker-placeholder": 49,
	"./placeholders/worker-placeholder.jpg": 49,
	"./prevention_form/alkohol": 50,
	"./prevention_form/alkohol.svg": 50,
	"./prevention_form/cannabis": 51,
	"./prevention_form/cannabis.svg": 51,
	"./prevention_form/gaming": 52,
	"./prevention_form/gaming.svg": 52,
	"./prevention_form/gluecksspiele": 53,
	"./prevention_form/gluecksspiele.svg": 53,
	"./prevention_form/kaufsucht": 54,
	"./prevention_form/kaufsucht.svg": 54,
	"./prevention_form/kennenlernen": 55,
	"./prevention_form/kennenlernen.svg": 55,
	"./prevention_form/koerperbild": 56,
	"./prevention_form/koerperbild.svg": 56,
	"./prevention_form/lebenskompetenz": 57,
	"./prevention_form/lebenskompetenz.svg": 57,
	"./prevention_form/mischkonsum": 58,
	"./prevention_form/mischkonsum.svg": 58,
	"./prevention_form/mobbing": 59,
	"./prevention_form/mobbing.svg": 59,
	"./prevention_form/partydrogen": 60,
	"./prevention_form/partydrogen.svg": 60,
	"./prevention_form/resilienz": 61,
	"./prevention_form/resilienz.svg": 61,
	"./prevention_form/snus": 62,
	"./prevention_form/snus.svg": 62,
	"./prevention_form/soziale-medien": 63,
	"./prevention_form/soziale-medien.svg": 63,
	"./prevention_form/stress": 64,
	"./prevention_form/stress.svg": 64,
	"./prevention_form/sucht": 65,
	"./prevention_form/sucht.svg": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;